import React from 'react';
import PropTypes from 'prop-types';
import Menu from '../Menu';
import Divider from '../Divider';
import Sidebar from '../Sidebar';
import Icon from '../Icon';
import Breadcrumbs from './bread-crumbs';
import MainMenu from './main-menu';
import MenuList from './menu-list';
import NotificationsMenu from './notifications-menu';
import './styles.css';

class RepVisitsFrame extends React.Component {
  static propTypes = {
    router: PropTypes.shape({
      location: PropTypes.object.isRequired,
    }).isRequired,
    children: PropTypes.node.isRequired,
  };

  state = {
    visible: false,
    secondaryMenu: false,
    path: this.props.router.location.pathname.split('/'),
  };

  componentWillReceiveProps = (nextProps) => {
    if (this.state.path !== nextProps.router.location.pathname) {
      this.setState((previousState, currentProps) => ({ ...previousState, path: nextProps.router.location.pathname.split('/') }));
    }
  }

  toggleVisibility = () => (this.setState((previousState, currentProps) => (
    { ...previousState, visible: !previousState.visible, path: this.props.router.location.pathname.split('/') })));

  toggleSecondaryMenu = () => this.setState((previousState) => ({ secondaryMenu: !previousState.secondaryMenu }));

  renderMenu = () => {
    const { secondaryMenu } = this.state;
    const { router } = this.props;
    return (
      <section>
        {secondaryMenu ? (
          <NotificationsMenu
            router={router}
            toggleVisibility={this.toggleVisibility}
            toggleSecondaryMenu={this.toggleSecondaryMenu}
            role="menu"
          />
        ) : (
          <MainMenu
            router={router}
            toggleVisibility={this.toggleVisibility}
            toggleSecondaryMenu={this.toggleSecondaryMenu}
            role="menu"
          />
        )}
      </section>
    );
  }

  renderSideBar = () => {
    const { visible } = this.state;
    return (
      <Sidebar
        styleName="sideWrapper"
        as={Menu}
        animation="overlay"
        width="thin"
        visible={visible}
        icon="labeled"
        vertical
        inverted
        className="menu visible-mobile-flex visible-tablet-flex hidden-computer"
      >
        {this.renderMenu()}
      </Sidebar>
    );
  }

  renderSideBarPusher = () => {
    const { visible, path } = this.state;
    const { children, router } = this.props;
    return (
      <Sidebar.Pusher dimmed={visible} styleName="pusherContent" className="dimmed-opacity">
        <Icon
          styleName="hamburgerIcon"
          name="content"
          aria-hidden="true"
          size="large"
          className="hidden-computer"
          onClick={this.toggleVisibility}
        />
        <Breadcrumbs styleName="breadcrumbText" className="hidden-computer" path={path} />
        <Divider className="hidden-computer" />
        <MenuList currentPathName={router.location.pathname} role="menu" className="hidden-mobile hidden-tablet" />
        <main aria-labelledby="pageTitle" styleName="content" id="content">
          {children}
        </main>
      </Sidebar.Pusher>
    );
  }

  render() {
    return (
      <div styleName="container">
        <Sidebar.Pushable styleName="pushableContent">
          {this.renderSideBar()}
          {this.renderSideBarPusher()}
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default RepVisitsFrame;
